module.exports = __webpack_public_path__ + "img/workout-notebook_B095GLS21D.1caf08b3.jpg";